import type { ReactNode } from "react";
import { Box, ButtonBase } from "@mui/material";

/**
 * The approved pill switch chip: outlined, filled with the accent when
 * selected; an optional red dot marks something live.
 */
export function PillChip({
  selected,
  onClick,
  children,
  ariaLabel,
  live = false,
}: {
  selected: boolean;
  onClick: () => void;
  children: ReactNode;
  ariaLabel?: string;
  live?: boolean;
}) {
  return (
    <ButtonBase
      onClick={onClick}
      aria-pressed={selected}
      aria-label={ariaLabel}
      sx={{
        flexShrink: 0,
        gap: 0.5,
        minHeight: 32,
        px: 1.5,
        borderRadius: "999px",
        border: 1,
        borderColor: selected ? "primary.main" : "divider",
        bgcolor: selected ? "primary.main" : "transparent",
        color: selected ? "primary.contrastText" : "text.primary",
        fontSize: "0.8125rem",
        fontWeight: selected ? 700 : 500,
        whiteSpace: "nowrap",
        "&.Mui-focusVisible": { outline: 2, outlineColor: "primary.main", outlineOffset: 2 },
      }}
    >
      {children}
      {live ? (
        <Box aria-hidden sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: "error.main" }} />
      ) : null}
    </ButtonBase>
  );
}
